import {
  format,
  formatDistanceStrict,
  lastDayOfMonth,
  startOfMonth,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import { DATE_FORMAT } from '@/shared/constants'

export function getDateFormat(date: Date | number, dateFormat: string): string {
  return format(date, dateFormat, { locale: ru })
}

export function getLastDayOfMonth(date: Date | number): Date {
  const lastDay = lastDayOfMonth(date)
  const dateWithTime = `${getDateFormat(lastDay, DATE_FORMAT.ymdDash)}T23:59:59`

  return new Date(dateWithTime)
}

export function getFirstDayOfMonth(date: Date | number): Date {
  return startOfMonth(date)
}

export function getDateDistance(blockAt: Date): string | number {
  const blockDate = new Date(blockAt)
  const currentDate = new Date()

  if (blockDate < currentDate) return 0

  const distance: string = formatDistanceStrict(blockDate, currentDate, {
    unit: 'day',
  }).replace('days', '')

  return distance
}
